module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_primaerlogo_neg.31f5bc80.pdf";